export const Services = {
   "PostOauth": {
      "path": "https://rrapiadmin.azurewebsites.net/",
      "method": "DELETE",
      "descrp": "GET REPORTS CATALOGS ******RR********"
   },
   "GetCustomerForUserId": {
      "path": "https://rrapiadmin.azurewebsites.net/",
      "method": "GET",
      "descrp": "GET customer for Id"
   },
   "Post_Data_Recovery": {
      "path": "https://rrapiadmin.azurewebsites.net/",
      "method": "POS",
      "descrp": "Post data recovery"
   },
   "AUDIT": {
      "path": "https://rrapiauditoria.azurewebsites.net/",
      "method": "",
      "descrp": "AUDIT"
   },
   "URL": {
      "path": "https://magicvision.web.app/",
      "method": "",
      "descrp": "Url Project"
   }
}